import { render, staticRenderFns } from "./MultiUploadBlock.vue?vue&type=template&id=4df5f89e"
import script from "./MultiUploadBlock.vue?vue&type=script&lang=js"
export * from "./MultiUploadBlock.vue?vue&type=script&lang=js"
import style0 from "./MultiUploadBlock.vue?vue&type=style&index=0&id=4df5f89e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports